<template>
  <div class="pinwallList" @click="closeSidebar()">
    <FixedHeader
      @clickedLogin="(showLogin = !showLogin), (showAdd = false)"
      :showLogin="showLogin"
      :showForm="showAdd || fullSidebar"
      :showLoginBtn="!showSearch || windowWidth >= 700"
      @show="showSearchInput"
      @input="search"
      @visible="setClass"
      :showSearchInput="showSearch"
      :view="'pinwallList'"
    >
      <div
        v-if="!showSearch || windowWidth >= 700"
        class="menu-button"
        @click.stop.prevent="fullSidebar = !fullSidebar"
      >
        <b-icon
          :icon="windowWidth < mobileWidth && fullSidebar ? 'close' : 'menu'"
        ></b-icon>
      </div>
      <a @click="goTo()">
        <img
          v-if="!showSearch || windowWidth >= 700"
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
      <b-button
        v-if="!showSearch || windowWidth >= 700"
        :disabled="disablePinwallAddButton || showPassword"
        class="add-button action-button"
        :style="user ? 'right: 67px' : ''"
        :type="showAdd ? 'is-danger' : 'is-success'"
        @click="showPinwallAdd"
        :icon-left="showAdd ? 'close' : 'plus'"
        :title="pinwallButtonTitle"
        rounded
        >{{ showAdd ? $t("close") : "Pinwall" }}</b-button
      >
    </FixedHeader>
    <Sidebar
      :class="sidebarClass"
      @select="spaceSelected"
      @edit="editSpaceItem"
      @delete="deleteSpaceItem"
      :selectedSpace="selectedSpace"
      :fullSidebar="fullSidebar"
      :spaces="spaces"
      :tenants="tenants"
      :tenant="tenant"
    >
      <button
        :disabled="
          !tenant.collaboration &&
            !tenant.editable &&
            !selectedSpace.tenantEditable
        "
        @click.stop.prevent="
          (showSpaceAdd = !showSpaceAdd), (fullSidebar = true)
        "
        type="submit"
        class="button add-space-button is-text"
      >
        <b-icon :icon="showSpaceAdd ? 'close' : 'plus'"></b-icon>
      </button>
      <AddSpace
        v-if="fullSidebar && showSpaceAdd"
        @added="showSpaceAdd = false"
      />
    </Sidebar>
    <Add
      :space="selectedSpace || spaces[0]"
      :spaces="spaces"
      @added="showAdd = false"
      @spaceChange="setSpaceChange"
      v-if="showAdd"
    ></Add>
    <div :class="fullSidebar ? 'content' : 'content-sidebar-not-visible'">
      <div class="buttons">
        <b-dropdown
          aria-role="list"
          position="is-bottom-left"
          v-model="sort"
          @change="sortPinwalls"
        >
          <button
            class="button is-primary is-rounded sort-button"
            slot="trigger"
          >
            <span>{{
              sort !== "" ? $t(`sort.${sort}`) : $t("sort.none")
            }}</span>
            <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item disabled>{{ $t("sort.sorting") }}</b-dropdown-item>
          <b-dropdown-item value aria-role="listitem">{{
            $t("sort.none")
          }}</b-dropdown-item>
          <b-dropdown-item value="new" aria-role="listitem">{{
            $t("sort.new")
          }}</b-dropdown-item>
          <b-dropdown-item value="old" aria-role="listitem">{{
            $t("sort.old")
          }}</b-dropdown-item>
          <b-dropdown-item value="likes" aria-role="listitem">{{
            $t("sort.likes")
          }}</b-dropdown-item>
        </b-dropdown>
      </div>
      <div
        :style="
          `min-height: ${
            fullSidebar ? windowHeight - 139 : windowHeight - 115
          }px`
        "
      >
        <List
          :selectedSpace="selectedSpace"
          @like="like"
          @selectSpace="selectSpace"
          :items="filteredPinwalls"
        ></List>
        <div v-if="showPassword">
          <Password @save="loadPinwall" :tries="passwordTries" />
        </div>
      </div>
    </div>
    <Footer :sidebar="fullSidebar" />
  </div>
</template>

<script>
// @ is an alias to /src
import FixedHeader from "@/components/FixedHeader";
import Footer from "@/components/Footer";
import Sidebar from "@/components/Sidebar";
import Add from "@/components/pinwallList/Add";
import AddSpace from "@/components/space/Add";
import Password from "@/components/core/Password";
import List from "@/components/pinwallList/List";
import { goTo } from "../mixins/goTo.js";
import { getScrollY } from "../mixins/getScrollY.js";
import { openUsernameDialog } from "../mixins/openUsernameDialog.js";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "pinwallList",
  computed: {
    ...mapGetters([
      "pinwalls",
      "spaces",
      "tenants",
      "selectedSpace",
      "user",
      "currentScrollPosition",
      "storedSpaces",
      "tenant",
      "viewHeight",
      "darkMode"
    ]),
    filteredPinwalls() {
      const pinwalls = this.pinwalls;
      return pinwalls.filter(pinwall => {
        return (
          (pinwall.title || "")
            .toLowerCase()
            .indexOf((this.textFilter || "").toLowerCase()) >= 0
        );
      });
    }
  },
  mixins: [goTo, getScrollY, openUsernameDialog],
  components: {
    FixedHeader,
    Footer,
    Sidebar,
    Add,
    List,
    AddSpace,
    Password
  },
  data: () => {
    return {
      showAdd: false,
      showSpaceAdd: false,
      lastSpace: null,
      textFilter: "",
      sidebarClass: "",
      disablePinwallAddButton: false,
      pinwallButtonTitle: "Create Pinwall",
      subscribeIds: [],
      isSocketSubscribed: false,
      editSpaceOpen: false,
      fullSidebar: true,
      showPassword: false,
      mobileWidth: process.env.VUE_APP_MOBILE_WIDTH,
      passwordTries: 0,
      pinwallCount: 0,
      showLogin: false,
      showSearch: false,
      password: "",
      sort: ""
    };
  },
  watch: {
    user: "load",
    getScrollY: "handleScroll"
  },
  methods: {
    ...mapMutations([
      "setSpace",
      "setTenant",
      "setSpaces",
      "removePinwall",
      "setStoredSpace",
      "setStoredLike",
      "addPinwall",
      "addSpace",
      "setViewHeight"
    ]),
    ...mapActions(["loadPinwalls", "loadSpaces", "deleteSpace", "likePinwall"]),
    spaceSelected(item) {
      this.spaces.map(item => {
        if (item.id === this.selectedSpace.id) {
          item.showEdit = false;
        }
      });

      this.editSpaceOpen = item.editable ? true : false;
      window.scrollTo(0, 0);
      this.setSpaces(this.spaces);

      this.setSpace(item);
      this.readStoredSpace(item);
      this.showPassword = false;
      this.passwordTries = 0;
      this.setSpace(item);
      this.lastSpace = item;
      this.loadPinwall();
    },
    showPinwallAdd() {
      if (this.showAdd && this.selectedSpace.id !== this.lastSpace.id) {
        this.setSpace(this.lastSpace);
        this.loadPinwall();
      }
      this.showAdd = !this.showAdd;
      this.showLogin = false;
    },
    setSpaceChange(space) {
      this.setSpace(space);
      this.loadPinwall();
    },
    selectSpace(spaceId) {
      if (spaceId !== "all") {
        var space = this.spaces.find(item => {
          return item.spaceId === spaceId;
        });

        if (space) {
          this.spaceSelected(space);
        }
      }
    },
    deleteSpaceItem(item) {
      this.$buefy.dialog.confirm({
        message: this.$t("pinwallList.deleteSpace"),
        onConfirm: () => {
          this.deleteSpace(item).then(spaces => {
            this.$socket.emit(
              process.env.VUE_APP_SOCKET_ON,
              `${this.tenantId}`,
              spaces
            );
            this.loadPinwall();
          });
        }
      });
    },
    editSpaceItem(items) {
      this.editSpaceOpen = true;
      this.setSpaces(items);
    },
    closeSidebar() {
      if (
        this.windowWidth <= this.mobileWidth &&
        this.fullSidebar === true &&
        !this.editSpaceOpen &&
        !this.showSpaceAdd
      ) {
        this.fullSidebar = false;
      }
    },
    search(value) {
      const searchUrl = `/search?searchValue=${value}`;
      this.goTo(searchUrl);
    },
    showSearchInput(visible) {
      this.showSearch = visible;
    },
    like(pinwall) {
      this.likePinwall(pinwall).then(() => {
        this.setStoredLike(pinwall.id);
      });
    },
    readStoredSpace(space) {
      this.storedSpace = null;
      if (this.storedSpaces) {
        this.storedSpace = this.storedSpaces.find(item => {
          return item.tenant === this.tenantId && item.space === space.spaceId;
        });
      }
      this.sort =
        this.storedSpace && this.storedSpace.sort
          ? this.storedSpace.sort
          : "new";

      this.sort = this.$route.query.sort || this.sort || "new";

      if (this.$route.query.sort && this.$route.query.sort === "none") {
        this.sort = "";
      }

      this.password =
        this.storedSpace && this.storedSpace.password
          ? this.storedSpace.password
          : this.$route.query.password;
    },
    sortPinwalls(value) {
      this.setViewHeight(0);
      this.sort = value;

      this.$router.push({
        query: { sort: this.sort ? this.sort : "none" }
      });

      // this.loadPinwall();
    },
    setClass(visible) {
      this.sidebarClass = visible ? "nav-up" : "nav-down";
    },
    loadPinwall(password) {
      if (
        this.selectedSpace.collaboration == null ||
        this.selectedSpace.collaboration
      ) {
        this.disablePinwallAddButton = !this.user;
        this.pinwallButtonTitle = this.disablePinwallAddButton
          ? this.$t("buttons.addPinwallDisabled")
          : this.$t("buttons.addPinwall");
      } else {
        this.disablePinwallAddButton = !this.selectedSpace.editable;
        this.pinwallButtonTitle = this.disablePinwallAddButton
          ? this.$t("buttons.addPinwallCollabDisabled")
          : this.$t("buttons.addPinwall");
      }

      this.loadPinwalls({
        tenant: this.tenantId,
        space: this.selectedSpace.spaceId,
        password: password || this.password,
        sort: this.sort
      })
        .then(space => {
          this.showPassword = false;
          this.pinwallCount = space.pinwallCount;
          this.setStoredSpace({
            tenant: this.tenantId,
            space: space.spaceId,
            password: space.password,
            sort: this.sort
          });

          const subscribeId = space.password
            ? `${this.tenantId}-${space.spaceId}-${space.password}`
            : `${this.tenantId}-${space.spaceId}`;

          let foundSubscribeId = this.subscribeIds.find(
            item => item === subscribeId
          );

          if (!foundSubscribeId) {
            this.sockets.subscribe(subscribeId, data => {
              if (data.pinwall) {
                this.removePinwall(data.pinwall);
              } else {
                this.addPinwall(data);
              }
            });
            this.subscribeIds.push(subscribeId);
          }

          this.showAdd = this.showAdd ? !this.disablePinwallAddButton : false;
        })
        .catch(() => {
          this.showAdd = false;
          this.showPassword = true;
          this.passwordTries = this.passwordTries + 1;
        });
    },
    load() {
      this.loadSpaces(this.tenantId).then(space => {
        this.setSpace(space);
        this.lastSpace = space;
        if (!this.isSocketSubscribed) {
          this.sockets.subscribe(this.tenantId, data => {
            if (Array.isArray(data)) {
              var currentSpaceId = this.selectedSpace.spaceId;
              this.setSpaces(data);
              var found = data.find(space => space.spaceId == currentSpaceId);
              if (!found) {
                this.loadPinwall();
              }
            } else {
              this.addSpace(data);
            }
          });
          this.isSocketSubscribed = true;
        }

        this.loadPinwall();
      });
    },
    handleScroll() {
      const scrollYPosition = window.scrollY + window.innerHeight;

      var additionalHeight = (this.viewHeight / 100) * 20;
      var wantedHeight =
        additionalHeight <= 540
          ? this.viewHeight + additionalHeight
          : this.viewHeight + 540;

      if (
        scrollYPosition >= wantedHeight &&
        this.pinwalls.length < this.pinwallCount &&
        !this.isLoading
      ) {
        this.setViewHeight(scrollYPosition);
        this.loadPinwall();
      }
    }
  },
  created() {
    if (this.user && !this.user.username) {
      this.openUsernameDialog(this.$t("user.enterUserName"));
    }

    this.setViewHeight(0);
    const params = this.$route.params;
    this.tenantId = params.tenant || "pinwall";
    window.scrollTo(0, this.currentScrollPosition);
  },
  mounted() {
    this.password = this.$route.query.password;
    this.storedSpace = null;
    this.readStoredSpace(this.selectedSpace);
    this.load();

    if (this.windowWidth < process.env.VUE_APP_MOBILE_WIDTH) {
      this.fullSidebar = false;
    }
  }
};
</script>
